module.exports = __webpack_public_path__ + "img/settings.aa4648d7.svg";